import { useI18n } from '@cascade/react/i18n';
import { TicketsGate as SharedTicketsGate } from '@cascade/react/tickets';
import { Loading } from '@cascade/ui-library';
import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { HOME_PATH } from '#config/index.ts';
import { TicketsFailed } from '#views/tickets-failed/index.ts';

export const TicketsGate = ({ children }: PropsWithChildren) => {
  const { translate } = useI18n();

  return (
    <SharedTicketsGate
      loading={<Loading contain label={translate('pending.tickets')} />}
      failed={<TicketsFailed />}
      unavailable={<Navigate to={HOME_PATH} replace />}
    >
      {children}
    </SharedTicketsGate>
  );
};
